export default {"src":"/_next/static/media/quotes-background.ecaa5e34.svg","height":1399,"width":1440,"blurWidth":0,"blurHeight":0};